import { LoadingButton } from '@mui/lab';
import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import { SnackbarContext } from '../../../Providers/SnackbarProvider';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { graphql } from 'gql';
import { EpisodeData } from '../types';

const UpdateEpisodes = graphql(`
    mutation UpdateEpisodes($where: EpisodeWhere, $update: EpisodeUpdateInput) {
        updateEpisodes(where: $where, update: $update) {
            episodes {
                id
                title
            }
        }
    }`);

type Props = {
    open: boolean
    onClose: () => void
    episode: EpisodeData
}

export default function EditEpisodeDialog({ open, onClose, episode }: Props) {
    const { success, error } = useContext(SnackbarContext);

    const [title, setTitle] = useState<string>(episode.title);

    const [updateEpisodes, { loading }] = useMutation(UpdateEpisodes);

    const handleSave = async () => {
        try {
            await updateEpisodes({
                variables: { where: { id: episode.id }, update: { title }},
            });

            onClose();
            success('Episode edited');
        } catch (e) {
            // @ts-ignore
            error('Failed to edit episode. ' + e.message);
        }
    }

    const handleClose = () => {
        setTitle(episode.title);
        onClose();
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            handleSave();
        }
    }

    if (!episode) {
        return null;
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Edit Episode</DialogTitle>
            <DialogContent>
                <TextField
                    sx={{ mt: 1, mb: 1 }}
                    label="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant='text'>Cancel</Button>
                <LoadingButton
                    onClick={handleSave}
                    disabled={!title}
                    variant='contained'
                    loading={loading}
                >
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}